import { Overlay, Button, Loading, Uploader, Toast, Tab, Tabs, Tabbar, TabbarItem, Row, Col, Swipe, SwipeItem } from 'vant'
 
const vant = {
  install: function(Vue) {
    Vue.use(Overlay)
    Vue.use(Button)
    Vue.use(Loading)
    Vue.use(Uploader)
    Vue.use(Toast)
    Vue.use(Tab)
    Vue.use(Tabs)
    Vue.use(Tabbar)
    Vue.use(TabbarItem)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Swipe)
    Vue.use(SwipeItem)
  }
}
 
export default vant